import $ from 'jquery'
import Screen from "./screen";
import SimpleBar from 'simplebar'; // or "import SimpleBar from 'simplebar';" if you want to use it manually.

export default class CustomScrollbar {
  init() {
    if( $('#js-custom-scrollbar').length ) {
      const simpleBar = new SimpleBar(document.getElementById('js-custom-scrollbar'), { 
        autoHide: false,
        forceVisible: 'y',
        scrollbarMaxSize: 100,
      });

      $(window).on('resize', function () {
        if( $(window).innerWidth() > $(window).innerHeight() ) {
          simpleBar.recalculate();
        }
      })
    }
  }
}